import {StoreType} from '../../../types/sharedTypes';

export const allTariffsSelector = (state: StoreType) => {
  return state.tariffReducer.tariffResult;
}
